var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#F4B840",
    fillOpacity: 0.15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_107_2263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.6944 23.0285C44.5457 22.5717 44.1505 22.2386 43.6758 22.1697L39.1569 21.5129L37.1353 17.4175C36.9234 16.9871 36.4848 16.7144 36.0042 16.7144C35.5236 16.7144 35.085 16.9871 34.8731 17.4175L32.8514 21.513L28.3318 22.1697C27.857 22.2387 27.4618 22.5718 27.3132 23.0285C27.1646 23.4853 27.2886 23.9868 27.6328 24.322L30.9039 27.5097L30.131 32.0105C30.0496 32.484 30.2443 32.9626 30.6329 33.2448C31.0223 33.5282 31.5374 33.5631 31.962 33.3409L36.0045 31.2158L40.0461 33.3409C40.4806 33.5688 40.9936 33.5218 41.3753 33.2448C41.7638 32.9626 41.9585 32.4841 41.8772 32.0109L41.1051 27.5097L44.3753 24.322C44.7191 23.9868 44.8423 23.4852 44.6944 23.0285Z",
    fill: "#F4B840"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0472 35.9387H30.953C30.2562 35.9387 29.6913 36.5037 29.6913 37.2005V55.2858H42.3089V37.2005C42.3089 36.5037 41.744 35.9387 41.0472 35.9387Z",
    fill: "#F4B840"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3354 40.9858C17.6385 40.9858 17.0736 41.5508 17.0736 42.2476V54.2883C17.0736 54.8393 17.5202 55.2859 18.0712 55.2859H27.1678V40.9858H18.3354Z",
    fill: "#F4B840"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6644 46.0327H44.832V55.2857H53.9286C54.4796 55.2857 54.9262 54.8391 54.9262 54.2881V47.2945C54.9261 46.5977 54.3612 46.0327 53.6644 46.0327Z",
    fill: "#F4B840"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_107_2263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.5714,
    height: 38.5714,
    fill: "white",
    transform: "translate(16.7143 16.7144)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContest);
export default __webpack_public_path__ + "static/media/Contest.c745bf1fec21091cdf7e9c9251aa1e05.svg";
export { ForwardRef as ReactComponent };